<template>
  <div class="landing">
    <breadcrumb v-bind:path1="path1" :path2="activeLanding.Name"></breadcrumb>
    <div class="landing-header">
      <div class="page-width">
        <h4 class="landing-title">{{activeLanding.Name}}</h4>
        <div class="desc-container">
          <img class="landing-image" :src="activeLanding.Image" />
          <p class="desc" >{{activeLanding.CategoryDescription}}</p>
        </div>
        <div class="filters-toolbar-wrapper">
          <div class="filters-toolbar__item-child">
            <p>{{ $t('sortBy') }} :</p>
            <el-select v-model="option" v-bind:placeholder="$t('pleaseSelectSortingMethod')" value="" @change="updateFilter">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div v-if="this.isLoading && this.list.length" class="product-listing-container">
      <div class="page-width">
        <div class="loadmore disableBtn">
          <span>{{ $t('loadingProducts')}}</span>
          <i class="loading">
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
          </i>
        </div>
      </div>
    </div>
    <div v-if="!this.isLoading && this.list.length" class="product-listing-container">
      <div class="page-width">
        <h2 class="related-products">{{ $t('relatedProducts') }}</h2>
        <ul>
          <li v-for="(item, index) in list" v-bind:key="index" v-if="!item.IsStopSale">
            <productCard v-if='$i18n.locale=="en"'
              v-bind:img="item.ThumbnailLarge"
              v-bind:link="item.link"
              v-bind:name="item.Name"
              v-bind:isPromotion="item.IsPromotion"
              v-bind:price="item.Price"
              v-bind:item="item"
              v-bind:quantity="item.Quantity"
              v-bind:key="index"
            ></productCard>
            <productCard v-if='$i18n.locale=="ch"'
              v-bind:img="item.ThumbnailLarge"
              v-bind:link="item.link"
              v-bind:name="item.Description"
              v-bind:isPromotion="item.IsPromotion"
              v-bind:price="item.Price"
              v-bind:item="item"
              v-bind:quantity="item.Quantity"
              v-bind:key="index"
            ></productCard>
          </li>
        </ul>
        <div class="loadmore disableBtn">
          <span>{{ $t('noMoreProducts')}}</span>
          <i class="loading">
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
          </i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import axios from 'axios';
import productCard from '../productCard';
import breadcrumb from '@/components/breadcrumb';
import { CUSTOMER_INFORMATION_URL } from '../../api/url';
import {
  isUserAuthenticated,
  setLocalCart,
  getLocalCart
} from '../../store/modules/cart';

export default {
  name: 'landing',
  components: {
    breadcrumb,
    productCard
  },
  props: {
    itemData: [],
  },
  metaInfo() {
    return {
    title: `Elegant Granite - ${this.activeLanding.MetaTitle}`,
    meta: [
        { name: 'description', content: `${this.activeLanding.MetaDescription}` },
        { name: 'keywords', content: `${this.activeLanding.MetaKeywords}` },
        { name: 'robots', content: "index,follow" }
      ]
    }
  },
  data() {
    return {
      path1: {
        name: this.$t('apoodrInc'),
        path: '/asian-food',
      },
      landingCategory: '',
      currentCategory: '',
      list: [],
      isLoading: false,
      // drop down filter
      option:"",
      options: [{
        value: '1',
        label: 'Alphabetically, A-Z'
      }, {
        value: '2',
        label: 'Alphabetically, Z-A'
      }, {
        value: '3',
        label: 'Price, low to high'
      }],
    }
  },
  methods: {
    ...mapActions('search',['fetchProducts']),
    ...mapActions('products',['fetchCategories']),
    ...mapMutations('products', ['updateActiveProduct', 'updateActiveLanding']),
    ...mapMutations('checkout', ['setPricesForCheckout', 'saveTotalPrice', 'saveGrandTotal', 'clearPromoCode', 'clearCard']),
    isOutOfStock(item) {
      if(item.IsOverSaleable) {
        return false;
      }
      return item.StockLevel > 0 ? false : true
    },
    updateFilter(value) {
      if(value === '1') {
        this.list = this.list.sort((a,b) => {
          return a.Name[0] > b.Name[0] ? 1 : -1;
        })
      }
      if(value === '2') {
        this.list = this.list.sort((a,b) => {
          return a.Name[0] < b.Name[0] ? 1 : -1;
        })
      }
      if(value === '3') {
        this.list = this.list.sort((a,b) => {
          return a.Price - b.Price;
        })
      }
    },
    goToProductDetail(product) {
      this.updateActiveProduct(product.ProductNum);
      this.$router.push({ path: '/productDetails', query: { productNum: product.ProductNum}})
    },
    goToCategoryPage(cat) {
      this.updateActiveCategory(cat);
      this.$router.push({name: 'landing', query: cat.Key})
    },
    searchProduct() {
      this.$router.push({ path: 'search', query: { product: this.searchTerm }})
    },
    isB2B() {
      const token = localStorage.getItem('token');
      const config = {
        method: 'get',
        url: CUSTOMER_INFORMATION_URL,
        headers: {
          Authorization: `JWT ${token}`,
        }
      };
      let b2b = axios(config)
      .then( (res) => {
        return res.data.IsBusiness;
      })
      return b2b;
    },
    checkGroups(newVal) {
      if (!newVal) {
        newVal = this.groups;
      }
       let route = this.$route.path;
        newVal.map( group => {
        group.Categories.map( category => {
          if (route.slice(1) === category.Key) {
            this.updateActiveLanding(category);
            this.isLoading = true;
            this.fetchCategories([category.ProductCategory_id, this.business])
            .then( res => {
              this.isLoading = false;
              let ctemp1 = [];
              let ctemp2 = [];
              let catOut = [];
              let catReg = [];
              res.data.map((a)=>{
                if (this.isOutOfStock(a)) {
                  ctemp2.push(a)
                } else {
                  ctemp1.push(a)
                }
              })
              catOut = ctemp2.sort((a,b)=>{
                return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
              });
              catReg = ctemp1.sort((a,b) => {
                return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
              })
              this.list = catReg.concat(catOut);
            })
          }
        });
      });
    },
  },
    beforeRouteLeave(to, from, next) {
    if (isUserAuthenticated() && to.name === 'purchase') {
      this.$store.dispatch('cart/getCart')
      .then(() => {
      const cartItems = {};
      cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
      cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
      cartItems.ShippingMethod = "Delivery";
      cartItems.Tip = 0;
      cartItems.TipPercentage = 0;
      cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
      this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
      .then(() => {
        this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
        })
      })
    }
    this.clearPromoCode();
    this.clearCard();
    next();
  },
  watch: {
    activeLanding: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.fetchCategories([newVal.ProductCategory_id, this.business])
        .then(res => {
          let ctemp1 = [];
          let ctemp2 = [];
          let catOut = [];
          let catReg = [];
          res.data.map((a)=>{
            if (this.isOutOfStock(a)) {
              ctemp2.push(a)
            } else {
              ctemp1.push(a)
            }
          })
          catOut = ctemp2.sort((a,b)=>{
            return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
          });
          catReg = ctemp1.sort((a,b) => {
            return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
          })
          this.list = catReg.concat(catOut);
        })
        .catch(err => {
          console.log('err fetching product', err);
        })
      }
    },
    groups: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.checkGroups(newVal);
      }
    },
    '$route': {
      immediate: true,
      handler(newVal) {
        this.checkGroups();
      }
    },
    business: function(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.checkGroups();
      }
    }
  },
  computed: mapState({
    groups: state => state.navbar.allGroups,
    activeLanding: state => state.products.activeLanding,
    business: state => state.auth.userDetails.IsBusiness,
  }),
  mounted() {
    if (isUserAuthenticated()) {
      this.isB2B()
      .then( (res) => {
        this.checkGroups();
      });
    }
  },
}
</script>

<style lang="less">
@import "../../assets/css/public.less";
@import "../../assets/css/landing.less";
</style>



// WEBPACK FOOTER //
// src/view/Footer/landingPage.vue